(function () {
    document.querySelector('#btn-main-menu').addEventListener('click', (event) => {
        // Focus the close button
        const closeBtn = document.getElementById('btn-main-menu-close');
        closeBtn.focus()
        closeBtn.addEventListener('click', (event) => {
            /**
             * We're going to mimic the escape key being pressed.
             * 
             * This is needed so that the data-toggle will pick up the
             * control of this particular set of events and make sure that
             * the menu is closed in an accessible way.
             */
            document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }));
        }, { once: true });
    }, false);
}());